import { AxiosError } from 'axios';
import debounce from 'debounce';
import ErrorHandler from '@/support/ErrorHandler.ts';
import { AddressCheck, AddressCheckPayload } from '@/models/AddressCheck.ts';

export default class AddressHelper {
  public updateDebounce: () => void = debounce(() => { this.update(); }, 400);

  public country: string = '';

  public isExtra = false;

  public editToggleValue = false;

  private zipCode: string = '';

  private number: string = '';

  private addition: string = '';

  private hasSearched = false;

  private hasFound = false;

  private previousPayload : string = '';

  public setAddressMethod: (addressCheck: AddressCheck | null, isExtra: boolean) => void  = (addressCheck: AddressCheck | null, isExtra: boolean): void => { };

  public handleInput(key: string, event: any): void {
    if (key === 'Country' && event.value !== undefined) { this.country = event.value; }
    if (key === 'ZipCode') { this.zipCode = event.target.value; }
    if (key === 'Number') { this.number = event.target.value; }
    if (key === 'Addition') { this.addition = event.target.value; }
    this.updateDebounce();
  }

  private async update(): Promise<void> {
    if (! this.hasPostNlValidation) { return; }
    const payload: AddressCheckPayload = {
      zip_code: this.zipCode,
      house_number: this.number,
      addition: this.addition,
    }
    // Do not check when empty
    if (this.zipCode == '' || this.number == '') {
      return;
    }
    // Do not re-check on the same address
    if (`${this.zipCode}-${this.number}-${this.addition}` === this.previousPayload) {
      return;
    }
    this.previousPayload = `${this.zipCode}-${this.number}-${this.addition}`;

    this.hasSearched = false;
    const addressCheck: AddressCheck | null = await this.checkPostNl(payload);
    this.setAddressMethod(addressCheck, this.isExtra);
    this.hasFound = !! addressCheck;
    this.hasSearched = true;
  }

  private async checkPostNl(payload: AddressCheckPayload): Promise<AddressCheck | null> {
    if (! payload.zip_code || ! payload.house_number) { return null; }
    const addressCheck: AddressCheck | null = await new AddressCheck()
      .postCheck(payload)
      .then((item: AddressCheck | null): AddressCheck | null => {
        return item && item.streetName ? item : null; // returns array if no result, convert to null
      })
      .catch((error: AxiosError): null => {
        ErrorHandler.network(error);
        return null;
      });
    return addressCheck;
  }

  public get hasPostNlValidation(): boolean {
    return !! this.country && ['nl'].includes(`${this.country}`.toLowerCase());
  }

  public get showText(): boolean {
    return this.hasPostNlValidation && this.hasSearched && this.hasFound;
  }

  public get showEditToggle(): boolean {
    return this.hasPostNlValidation && this.hasSearched && ! this.hasFound && !! this.zipCode && !! this.number;
  }

  public get showFields(): boolean {
    return ! this.hasPostNlValidation || (this.hasSearched && ! this.hasFound && this.editToggleValue);
  }
}
